import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React, { createContext, useContext } from 'react'

import { getActionValues } from '../../_constants/actions'
import { sessionsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = createContext()
const { Provider } = Context
export const usePublicTokensState = () => useContext(Context) || {}
export const usePublicTokens = () => usePublicTokensState()?.publicTokens || []

const QUERY = gql`
  query PublicTokens($page: Int, $search: String, $sort: PublicTokenSort, $filter: PublicTokenFilter) {
    publicTokens(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      name
      type
      action
      amountLeft
      expireDate
      token
      insertedAt
      enabled
    }
  }
`

const PublicTokensLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()
  const entity = useModalData()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'ACTION', type: type || 'DESC' },
      filter: { actions: getActionValues(entity), includeDisabled: true, ...filter }
    },
    client: sessionsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default PublicTokensLoader
